import styled from "styled-components";

export const Container = styled.div`
    width: 300px;
    margin: 100px auto;
    
    text-align: center;
`;
